import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BHistory } from 'app/modules/data-model/interaction/interaction';
import {
  BAttachment,
  BInteraction,
  InquiriesService as InquiryService,
  SingleInteractionService,
} from 'app/modules/data-model/data-model.module';
import { GenericDialogService } from 'app/common/common/generic-dialog/generic-dialog.service';
import { InteractionsService } from 'app/modules/data-model/interaction/interactions.service';
import { Message } from 'app/common/common/message/message.component';
import { HistoryVisualizationDetailComponent } from './history-visualization-detail.component';
import {
  PERM_VIEW_ENQUIRER,
  PERM_VIEW_ENQUIRY_QUESTION,
} from 'app/common/common/constants/permissions';

@Component({
  selector: 'app-history-visualization',
  templateUrl: './history-visualization.component.html',
  styleUrls: ['./history-visualization.component.scss'],
})
export class HistoryVisualizationComponent implements OnInit, OnDestroy {
  @Input() history: BHistory;
  @Input() attachments: BAttachment[];
  @Input() loggedInUserIsSysAdmin: boolean;

  leftBarHistoryCategories = ['fu_response', 'bounce_detected', 'error'];
  leftBarHistoryCategoriesMap = {
    fu_response: 'FOLLOW_UP_RECEIVED',
    bounce_detected: 'ERROR_EMAIL_COULD_NOT_BE_DELIVERED',
    error: 'ERROR',
  } as const;
  isInteractionClosedOrInReview: boolean = false;
  message: Message;
  requiredPermissions: string[] = [];

  private _interaction: BInteraction;
  private subs = new Subscription();

  constructor(
    private modalService: GenericDialogService,
    private interactionService: SingleInteractionService,
    private inquiryService: InquiryService,
    private interactionsService: InteractionsService
  ) {}

  ngOnInit(): void {
    this.requiredPermissions =
      this.history.category === 'fu_response'
        ? [PERM_VIEW_ENQUIRY_QUESTION, PERM_VIEW_ENQUIRER]
        : [PERM_VIEW_ENQUIRER];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  @Input()
  set interaction(interaction: BInteraction) {
    this._interaction = interaction;
    this.isInteractionClosedOrInReview = this._interaction?.isClosedOrInReview();
  }

  get interaction(): BInteraction {
    return this._interaction;
  }

  openHistory(): void {
    const modalRef = this.modalService.open(HistoryVisualizationDetailComponent, {
      width: '820px',
      maxWidth: '100%',
      minHeight: '100px',
      maxHeight: '85vh',
    });
    modalRef.componentInstance.historyObject = this.history;
    const category = this.history.category;
    modalRef.componentInstance.categoryTitleKey = this.leftBarHistoryCategoriesMap[category];
  }

  createQuestionFromFU(historyId: number): void {
    this.subs.add(
      this.modalService.confirmFollowUpConvert().subscribe(() => {
        this.subs.add(
          this.inquiryService.createQuestionFromFU(historyId).subscribe({
            next: () => {
              this.interactionService.refreshInteraction(this.interaction.id);
              this.message = undefined;
            },
            error: (error) => (this.message = Message.httpError('Add as New Question', error)),
          })
        );
      })
    );
  }

  resendToDept(): void {
    this.subs.add(
      this.interactionsService.resendToDept(this.interaction.pk(), this.history.pk()).subscribe({
        next: () => (this.message = Message.info('Successfully resend to department.')),
        error: (error) => (this.message = Message.httpError('Resend to department failed', error)),
      })
    );
  }
}
